"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdMediaType = void 0;
var AdMediaType;
(function (AdMediaType) {
    AdMediaType["Image"] = "IMAGE";
    AdMediaType["Video"] = "VIDEO";
})(AdMediaType || (exports.AdMediaType = AdMediaType = {}));
